import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import {
  AddRawProdsToRecipesRequestBody,
  AddRawProdsToRecipesResponse, CompareRecipeDetails,
  CopyRecipeRequestBody, DeleteMultipleRecipes,
  DeleteRecipesResponse,
  RawProdAssignedToRecipe,
  Recipe,
  RecipeRawProdsRequestBody,
  RecipeRequestBody,
  RemoveRawProdsToRecipesRequestBody,
  RemoveRawProdsToRecipesResponse,
} from './recipe.types';


export const useRecipe = (specNo: string, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Recipe>>({
    queryKey: ['recipes', specNo],
    queryFn: () => apiClient.get<Recipe>(`/recipes/${specNo}`),
    enabled,
  });
};

export const useFmsProdsReport = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<number[]>>({
    queryKey: ['fmsprod', 'report'],
    queryFn: () => apiClient.get<number[]>(`/recipes/fmsprod-report`),
    enabled,
  });
};

export const useRecipeDetails = (specNo: string, enabled: boolean = false) => {
  return useQuery<AxiosResponse<RawProdAssignedToRecipe[]>>({
    queryKey: ['recipeDetails', specNo],
    queryFn: () => apiClient.get<RawProdAssignedToRecipe[]>(`/recipes/${specNo}/details`),
    enabled,
  });
};

export const useCompareRecipeDetails = (specNo1: string,specNo2: string, enabled: boolean = false) => {
  return useQuery<AxiosResponse<CompareRecipeDetails[]>>({
    queryKey: ['recipeCompareDetails',specNo1,specNo2],
    queryFn: () => apiClient.get<CompareRecipeDetails[]>(`/recipes/compare/${specNo1}/${specNo2}`),
    enabled,
  });
};


export const useEditRecipe = (specNo: string) => {
  return useMutation((record: RecipeRequestBody) => {
    return apiClient.put(`/recipes/${specNo}`, record);
  });
};

export const useEditRecipeRawProds = () => {
  return useMutation((record: RecipeRawProdsRequestBody) => {
    return apiClient.put(`/recipes/details`, record);
  });
}

export const useRemoveRecipeRawProds = () => {
  return useMutation((record: RecipeRawProdsRequestBody) => {
    return apiClient.put(`/recipes/details/remove`, record);
  });
}

export const useAddRawProdsToRecipes = () => {
  return useMutation<AxiosResponse<AddRawProdsToRecipesResponse[]>, unknown, AddRawProdsToRecipesRequestBody>(
    (body: AddRawProdsToRecipesRequestBody) => {
      return apiClient.post<AddRawProdsToRecipesResponse[]>(`/recipes/details`, body);
    }
  );
};

export const useRemoveRawProdsToRecipes = () => {
  return useMutation<AxiosResponse<RemoveRawProdsToRecipesResponse[]>, unknown, RemoveRawProdsToRecipesRequestBody>(
    (body: RemoveRawProdsToRecipesRequestBody) => {
      return apiClient.post<RemoveRawProdsToRecipesResponse[]>(`/recipes/details/remove`, body);
    }
  );
};

export const useCopyRecipes = () => {
  return useMutation((record: CopyRecipeRequestBody) => {
    return apiClient.post(`/recipes`, record);
  });
};


export const useDeleteRecipes = () => {
  return useQuery<AxiosResponse<DeleteRecipesResponse[]>>({
    queryKey: 'DeleteRecipes',
    queryFn: () => apiClient.get<DeleteRecipesResponse[]>('/recipes/recipes-info')
  });
};

  export const useDeleteRecipeRecords = () => {
    return useMutation((record: DeleteMultipleRecipes) => {
      return apiClient.post('/recipes/recipes-delete', record)
    });
  };




